import { Element, Transforms } from 'slate';
import { RenderElementProps } from 'slate-react';
import { CustomEditor, CustomElement } from 'slate/types/slate';
import { HighlightElement } from './components/HighlightElement';
import { isHighlight } from './utils/highlights';

const withHighlight =
  (_options: Record<string, unknown> = {}) =>
  (editor: CustomEditor) => {
    const { isInline, renderElement, normalizeNode } = editor;
    editor.isInline = (element: CustomElement) => isHighlight(element) || isInline(element);

    editor.renderElement = (props: RenderElementProps) => {
      if (isHighlight(props.element)) {
        return <HighlightElement {...props} />;
      } else {
        return renderElement(props);
      }
    };

    editor.normalizeNode = (entry) => {
      const [node, path] = entry;
      if (Element.isElement(node) && node.type === 'highlight') {
        if (node.highlighted) {
          Transforms.setNodes(editor, { highlighted: false }, { at: path });
        }
      }
      normalizeNode(entry);
    };
    return editor;
  };

export default withHighlight;
